import api from 'services/api';

export const fetchPlaylists = async (channelHashId: string): Promise<any[]> => {
  const response = await api.get(`/api/channels/${channelHashId}/playlists/?page_size=100`);
  return response.data;
};
